// Source: app/scripts/directives/recaptcha.js
var recaptchaCallbacks = [];

var onRecaptchaLoad = function(response) {
  var c = recaptchaCallbacks || [];

  for (var i = 0; i < c.length; i++) {
    c[i]();
  }
}


Auction.directive('recaptcha', ['$timeout', function($timeout) {
  return {
    restrict: 'A',
    require: "?^^form",
    scope: {
      response: '=?ngModel',
      key: '=',
      theme: '=?',
      onCreate: '&',
      onSuccess: '&',
      onExpire: '&'
    },
    link: function(scope, element, attrs, ctrl) {
      var key = scope.key;
      if (!attrs.hasOwnProperty('key')) {
        throwNoKeyException();
      }

      scope.widgetId = null;
      if (!key) {
        return;
      }

      if (key.length !== 40) {
        throwNoKeyException();
      }

      var callback = function(gRecaptchaResponse) {
        // Safe $apply
        $timeout(function() {
          if (ctrl) {
            ctrl.$setValidity('recaptcha', true);
          }
          scope.response = gRecaptchaResponse;
          // Notify about the response availability
          scope.onSuccess({
            response: gRecaptchaResponse,
            widgetId: scope.widgetId
          });
        });

        // captcha session lasts 2 mins after set.
        $timeout(function() {
          if (ctrl) {
            ctrl.$setValidity('recaptcha', false);
          }
          scope.response = "";
          // Notify about the response availability
          scope.onExpire({
            widgetId: scope.widgetId
          });
        }, 2 * 60 * 1000);
      };


      function show() {
        scope.widgetId = grecaptcha.render(element[0], {
          theme: scope.theme || attrs.theme || null,
          callback: callback,
          sitekey: key
        });

        if (ctrl) {
          ctrl.$setValidity('recaptcha', false);
        }
        scope.onCreate({
          widgetId: scope.widgetId
        });
      }

      if (!window.grecaptcha) {
        recaptchaCallbacks.push(function() {
          show();
        });
      } else {
        show();
      }



    }
  }
}]);
